import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SchedulePreviewComponent } from "./schedule-preview/schedule-preview.component";
import { TargetPreviewComponent } from "./target-preview/target-preview.component";
import { ScheduleOptionPreview } from "./poll-preview.type";
import { ScaleQuestionComponent } from "../../../timeline/user-requests/poll-request/scale-question/scale-question.component";
import { ClosedQuestionComponent } from "../../../timeline/user-requests/poll-request/closed-question/closed-question.component";
import { FiveStarsQuestionComponent } from "../../../timeline/user-requests/poll-request/five-stars-question/five-stars-question.component";
import { AgreeDisagreeQuestionComponent } from "../../../timeline/user-requests/poll-request/agree-disagree-question/agree-disagree-question.component";
import { AllowCommentsPreviewComponent } from "./allow-comments-preview/allow-comments-preview.component";
import { Choice, PollType } from "../../polls.type";
import { ITeam } from "@teammood/team";
import { QuestionForPreview, RecurrencePreviewOption } from "../create-poll.type";
import { RecurrencePreviewComponent } from "./recurrence-preview/recurrence-preview.component";



@Component({
    selector: 'poll-preview',
    templateUrl: 'poll-preview.component.html',
    styleUrls: ['./poll-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        ScaleQuestionComponent,
        ClosedQuestionComponent,
        FiveStarsQuestionComponent,
        SchedulePreviewComponent,
        TargetPreviewComponent,
        AgreeDisagreeQuestionComponent,
        AllowCommentsPreviewComponent,
        RecurrencePreviewComponent
    ]
})
export class PollPreviewComponent {

    @Input() previewType: PollType;
    @Input() poll: QuestionForPreview;
    @Input() author: string;
    @Input() options: ScheduleOptionPreview; 
    @Input() selectedTeams: ITeam[];
    @Input() allowComments: boolean;
    @Input() recurrence: RecurrencePreviewOption; 
    @Input() state: string; 
  
    constructor(
    ) {}

}

